export default __webpack_public_path__ + "static/media/0008.dbf88950.png";